import { useUser, useClerk } from '@clerk/react'
import { Spinner } from './Spinner'

export function AdminGate({ children }: { children: React.ReactNode }) {
  const { user, isLoaded } = useUser()
  const clerk = useClerk()

  if (!isLoaded) {
    return (
      <div className="grid min-h-screen place-items-center">
        <Spinner />
      </div>
    )
  }

  const role = (user?.publicMetadata?.role as string | undefined) ?? null
  if (role !== 'admin') {
    return (
      <div className="grid min-h-screen place-items-center bg-bone-50 p-6 dark:bg-marrow-900">
        <div className="max-w-md text-center">
          <h1 className="font-serif text-3xl font-semibold text-marrow-900 dark:text-bone-50">
            Admin access required
          </h1>
          <p className="mt-3 text-sm text-marrow-800/70 dark:text-bone-200/70">
            Your account ({user?.primaryEmailAddress?.emailAddress ?? 'unknown'}) doesn't have the
            <span className="mx-1 rounded bg-bone-100 px-1.5 py-0.5 font-mono text-xs dark:bg-marrow-800">
              admin
            </span>
            role. Ask the team to grant it on the Clerk dashboard.
          </p>
          <button
            type="button"
            onClick={() => clerk.signOut()}
            className="mt-6 rounded-md bg-rust-500 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-rust-600"
          >
            Sign out
          </button>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
